import axios from "axios";
import { getApiUrl } from "../../config";

const clientBase = () => getApiUrl() + "/plugins/ada-scans";
const internalBase = () => getApiUrl() + "/plugins-internal/ada-scans";

const request = (method, url, { params, data } = {}) => axios.request({ method, url, params, data, withCredentials: true, crossorigin: true });

export const requestGetSites = () => request("get", clientBase() + "/sites");
export const requestGetScans = (siteUrl) => request("get", clientBase() + "/scans", { params: { site: siteUrl } });
export const requestGetScan = (scanId) => request("get", `${clientBase()}/scans/${encodeURIComponent(scanId)}`);

export const requestGetFleet = () => request("get", internalBase() + "/clients");
export const requestGetClientScans = (clientId, siteUrl) => request("get", `${internalBase()}/clients/${encodeURIComponent(clientId)}/scans`, { params: { site: siteUrl } });
export const requestGetStaffScan = (scanId) => request("get", `${internalBase()}/scans/${encodeURIComponent(scanId)}`);
export const requestGetRulePages = (scanId, ruleId, page, limit, onlyNew) =>
    request("get", `${internalBase()}/scans/${encodeURIComponent(scanId)}/rules/${encodeURIComponent(ruleId)}/pages`, { params: { page, limit, onlyNew: onlyNew ? 1 : 0 } });
export const requestImportScan = (file, clientId, scanDate) => {
    const data = new FormData();
    data.append("file", file);
    data.append("clientId", clientId);
    data.append("scanDate", scanDate);
    return request("post", internalBase() + "/scans", { data });
};
export const requestUpdateScanDate = (scanId, scanDate) => request("put", `${internalBase()}/scans/${encodeURIComponent(scanId)}`, { data: { scanDate } });
export const requestAddScanLink = (scanId, kind, id) => request("post", `${internalBase()}/scans/${encodeURIComponent(scanId)}/links`, { data: { kind, id } });
export const requestRemoveScanLink = (scanId, kind, id) =>
    request("delete", `${internalBase()}/scans/${encodeURIComponent(scanId)}/links/${encodeURIComponent(kind)}/${encodeURIComponent(id)}`);
export const requestDeleteScan = (scanId) => request("delete", `${internalBase()}/scans/${encodeURIComponent(scanId)}`);
export const requestGetLinkTargets = (clientId, q) => request("get", internalBase() + "/link-targets", { params: { clientId, q } });
export const requestSearchClients = (q) => request("get", internalBase() + "/client-search", { params: { q } });
